export default "__VITE_ASSET__f15165aa__"